import {Component, forwardRef, Input, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, FormGroup, FormBuilder} from '@angular/forms';
import {BehaviorSubject, Observable} from 'rxjs';
import {IBankamountData} from './bankamount.model';
import {BankamountService} from './bankamount.service';
import { TRANSLATE_PATH } from '../../project.model';
import {IIdentifier} from 'build/project/openapi-cast/project/project-openapi-cast.model';

@Component({
   selector: 'app-bankamount',
   templateUrl: './bankamount.component.html',
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => BankamountComponent)
      },
      {
         provide: NG_VALIDATORS,
         multi: true,
         useExisting: BankamountComponent
      }
   ],
   standalone: false
})
export class BankamountComponent implements OnInit, OnDestroy, ControlValueAccessor {
   public TRANSLATE_PATH = TRANSLATE_PATH; 

   public bankAmountForm: FormGroup = this.fb.group({});
   private loaded_: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   public loaded$: Observable<boolean> = this.loaded_.asObservable();
   private bankamountData_: IBankamountData = {} as IBankamountData;
   private id_: IIdentifier = {} as IIdentifier;


   @Input()
   get id (): IIdentifier {
      return this.id_;
   }

   set id (iid: IIdentifier) {
      if (!iid) return;

      this.sBankamount.loadData(iid).subscribe(_ => this.loaded_.next(true));

      this.id_ = iid;
   }

   @Input()
   set value (val: IBankamountData) {
      this.bankamountData_ = val;
   }

   get value (): IBankamountData {
      return this.bankamountData_;
   }


   constructor (private fb: FormBuilder, public sBankamount: BankamountService) {
   }

   ngOnInit (): void {
   }

   ngOnDestroy (): void {
  
   }
  
   writeValue (_obj: any): void {
      
   }

   registerOnChange (fn: any): void {
      this.onChange = fn;
   }

   registerOnTouched (fn: any): void {
      this.onTouched = fn;
   }

   validate (_control: AbstractControl): ValidationErrors | null {
      return null;
   }

   private onTouched () {}

   private onChange (_: IBankamountData) {}


}
